import { useNavigate } from "react-router-dom";
import rocket from "../assets/rocket-launch.svg";

const AccessGranted = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full min-h-screen bg-gradient-to-b from-emerald-100 via-amber-200 to-red-100 flex justify-center items-center p-4 md:p-8">
      <div className="bg-white/35 border border-white/40 backdrop-blur-md rounded-2xl shadow-[0_28px_70px_rgba(15,23,42,0.28)] w-full max-w-md p-10 flex flex-col items-center text-center gap-6">

        <div className="w-24 h-24 bg-green-500 rounded-full flex items-center justify-center shadow-lg">
          <img
            src={rocket}
            alt="rocket"
            className="w-12 h-12 object-contain"
          />
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-gray-800 mb-2">
            Access granted!
          </h2>
          <p className="text-gray-600 text-sm leading-relaxed">
            You can now start exploring your control panel.
          </p>
        </div>

        <button
          onClick={() => navigate("/")}
          className="w-full bg-[#C49A1F] hover:bg-[#A9821A] text-white py-3 rounded-xl transition font-medium"
        >
          Sign in
        </button>
      </div>
    </div>
  );
};

export default AccessGranted;